export default __webpack_public_path__ + "static/media/logo.c232402f.png";